import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const LIST_EMPLOYEES_FOR_REVIEW_CYCLES = gql`
  mutation ListEmployeesForReviewCycles($reviewCycleIds: [String!]!) {
    listofemployeesforreviecyclegivenreviewcycleid(
      reviewCycleIds: $reviewCycleIds
    ) {
      users {
        id
        group
        firstName
        lastName
        employeeNumber
        dateHired
        dateRehired
      }
      templateId
      dateToCompleteBy
    }
  }
`;


